export default __webpack_public_path__ + "static/media/background-video.6b2c92d9.mp4";